export enum LazoThreadConversationStatus {
  OPEN = "OPEN",
  ANSWERED = "ANSWERED",
  FINALIZED = "FINALIZED",
}
